module.exports = __webpack_public_path__ + "static/app-store-02368f495b165fee30e7bba18edd00ac.svg";